// extracted by mini-css-extract-plugin
module.exports = {"item":"MenuItem_item__2QPbh","active":"MenuItem_active__1areI"};